export default __webpack_public_path__ + "static/media/Inter-VariableFont_slnt,wght.f958c681.ttf";